import { type HistoryState } from '@tanstack/react-router';

declare module '@tanstack/react-router' {
  interface HistoryState {
    routineConfigurationReturnToPreviousView?: boolean;
  }
}

type ConfigurationHistory = {
  location: { state: HistoryState };
  canGoBack: () => boolean;
  back: () => void;
};

export const markRoutineConfigurationEntry = (
  state: HistoryState
): HistoryState => ({
  ...state,
  routineConfigurationReturnToPreviousView: true,
});

export const closeRoutineConfiguration = (
  history: ConfigurationHistory,
  showSavedView: () => void
) => {
  if (
    history.location.state.routineConfigurationReturnToPreviousView &&
    history.canGoBack()
  ) {
    history.back();
    return;
  }

  showSavedView();
};
